import { render, staticRenderFns } from "./PrjAppCom.vue?vue&type=template&id=1289f122&"
import script from "./PrjAppCom.vue?vue&type=script&lang=ts&"
export * from "./PrjAppCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports